import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { compose, withProps } from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle
} from 'react-google-maps'

import { GOOGLE_MAP_API_URL } from '../../config'
import { getAddressFromLocation } from '../../utils'

export const LocationMap = ({ location, setLocation }) => {
  useEffect(() => {
    getAddressFromLocation(`${location.lat},${location.lng}`).then(
      (address) => {
        setLocation({
          ...location,
          address
        })
      }
    )
  }, [])

  if (location) {
    location.lat = parseFloat(location.lat)
    location.lng = parseFloat(location.lng)

    const handleDragEnd = (e) => {
      getAddressFromLocation(`${e.latLng.lat()},${e.latLng.lng()}`).then(
        (address) => {
          setLocation({
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
            address,
            radius: location.radius
          })
        }
      )
    }

    return (
      <GoogleMap defaultZoom={12} defaultCenter={location}>
        <Marker position={location} draggable onDragEnd={handleDragEnd} />
        <Circle
          options={{
            strokeColor: 'transparent',
            fillColor: 'green',
            fillOpacity: 0.1
          }}
          center={location}
          radius={location.radius}
        />
      </GoogleMap>
    )
  } else {
    return <div>no location</div>
  }
}

LocationMap.propTypes = {
  location: PropTypes.object.isRequired
}

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_API_URL,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `90vh` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(LocationMap)



// WEBPACK FOOTER //
// ./src/components/LocationMap/index.js